module.exports = __webpack_public_path__ + "img/20190523203654微信截图_20190523204054.d4788912.png";